import { Component, inject, Input, OnInit } from '@angular/core';
import { NgxSmartModalService } from "ngx-smart-modal";
import { STORE_LINKS } from '../../constants/store-links';

@Component({
  selector: 'app-no-teams-info',
  templateUrl: './no-teams-info.component.html',
  styleUrl: './no-teams-info.component.scss'
})
export class NoTeamsInfoComponent implements OnInit {
  private _ngxSmartModalService: NgxSmartModalService = inject(NgxSmartModalService);

  @Input() city: string = '';

  constructor() {}

  ngOnInit(): void {}

  get appleStoreLink(): string {
    return STORE_LINKS['HENTERPANT'].appStore;
  }

  get googlePlayLink(): string {
    return STORE_LINKS['HENTERPANT'].googlePlay;
  }

  closeModal(): void {
    this._ngxSmartModalService.getModal('noTeamsModal').close();
  }
}

